import { BasicCoverageTypes } from '../../graphql/generated/types';
import { TModelOptionLabels } from '../types';

export const basicCoverageTypeLabels: TModelOptionLabels<BasicCoverageTypes> = {
  [BasicCoverageTypes.Custeio]: 'Custeio',
  [BasicCoverageTypes.Produtividade]: 'Produtividade',
  [BasicCoverageTypes.RiscoNomeado]: 'Risco Nomeado',
  [BasicCoverageTypes.Parametrico]: 'Paramétrico',
};
